import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var IBrand;
(function (IBrand) {
  var State;
  (function (State) {
    /**
     * The brand was newly created.
     */
    State["NEW"] = "NEW";
    State["WAITLISTED"] = "WAITLISTED";
    /**
     * THe onboarding form was sent to the brand.
     */
    State["ONBOARDING_FORM_SENT"] = "ONBOARDING_FORM_SENT";
    /**
     * The brand has started the onboarding form.
     */
    State["ONBOARDING_FORM_STARTED"] = "ONBOARDING_FORM_STARTED";
    /**
     * The brand has completed the onboarding form and we have their catalog.
     */
    State["ONBOARDING_FORM_COMPLETED"] = "ONBOARDING_FORM_COMPLETED";
    /**
     * The brand has had at least one product uploaded.
     */
    State["PROFILE_STARTED"] = "PROFILE_STARTED";
    /**
     * The brand has all of their products uploaded.
     */
    State["ALL_PRODUCTS_UPLOADED"] = "ALL_PRODUCTS_UPLOADED";
    State["PROFILE_IN_DESIGN_REVIEW"] = "PROFILE_IN_DESIGN_REVIEW";
    State["PROFILE_IN_FINAL_REVIEW"] = "PROFILE_IN_FINAL_REVIEW";
    State["PROFILE_ACTIVATED"] = "PROFILE_ACTIVATED";
    /**
     * The brand was rejected from Faire.
     * @deprecated
     */
    State["REJECTED"] = "REJECTED";
    State["PRE_ACTIVATION_REVIEW"] = "PRE_ACTIVATION_REVIEW";
    /**
     * Brand is uploading products in self serve
     */
    State["SELF_SERVE_PRODUCT_UPLOAD"] = "SELF_SERVE_PRODUCT_UPLOAD";
    /**
     * Brand has requested assistance in upload products while in self serve
     */
    State["ASSISTED_UPLOAD_PENDING"] = "ASSISTED_UPLOAD_PENDING";
    /**
     * Product catalog is being built by Faire in self serve
     */
    State["ASSISTED_UPLOAD_STARTED"] = "ASSISTED_UPLOAD_STARTED";
    /**
     * Brand is reviewing their store in self serve
     */
    State["SELF_SERVE_REVIEW"] = "SELF_SERVE_REVIEW";
    /**
     * Brand is reviewing their store after requesting self-serve assistance
     */
    State["ASSISTED_SELF_SERVE_REVIEW"] = "ASSISTED_SELF_SERVE_REVIEW";
    /**
     * Brand is being reviewed for fraud by Faire
     */
    State["FRAUD_REVIEW"] = "FRAUD_REVIEW";
    /**
     * Brand has been rejected for fraud
     */
    State["REJECTED_FOR_FRAUD"] = "REJECTED_FOR_FRAUD";
  })(State = IBrand.State || (IBrand.State = {}));
  var ReferralRewardsState;
  (function (ReferralRewardsState) {
    ReferralRewardsState["REFERRAL_REWARDS_STATE_UNKNOWN"] = "REFERRAL_REWARDS_STATE_UNKNOWN";
    ReferralRewardsState["REWARDS_NOT_APPLICABLE"] = "REWARDS_NOT_APPLICABLE";
    ReferralRewardsState["REWARDS_PENDING_APPROVAL"] = "REWARDS_PENDING_APPROVAL";
    ReferralRewardsState["REWARDS_APPROVED"] = "REWARDS_APPROVED";
    ReferralRewardsState["REWARDS_REJECTED"] = "REWARDS_REJECTED";
  })(ReferralRewardsState = IBrand.ReferralRewardsState || (IBrand.ReferralRewardsState = {}));
  var FederalTaxClass;
  (function (FederalTaxClass) {
    FederalTaxClass["C_CORPORATION"] = "C_CORPORATION";
    FederalTaxClass["S_CORPORATION"] = "S_CORPORATION";
    FederalTaxClass["INDIVIDUAL_OR_SOLE_PROPRIETOR"] = "INDIVIDUAL_OR_SOLE_PROPRIETOR";
    FederalTaxClass["LIMITED_LIABILITY_COMPANY"] = "LIMITED_LIABILITY_COMPANY";
    FederalTaxClass["OTHER"] = "OTHER";
  })(FederalTaxClass = IBrand.FederalTaxClass || (IBrand.FederalTaxClass = {}));
  var BrandLeadType;
  (function (BrandLeadType) {
    BrandLeadType["INBOUND"] = "INBOUND";
    BrandLeadType["OUTBOUND"] = "OUTBOUND";
    BrandLeadType["UNKNOWN"] = "UNKNOWN";
  })(BrandLeadType = IBrand.BrandLeadType || (IBrand.BrandLeadType = {}));
  var PurchaseOrderBrandType;
  (function (PurchaseOrderBrandType) {
    PurchaseOrderBrandType["NOT_A_PURCHASE_ORDER_BRAND"] = "NOT_A_PURCHASE_ORDER_BRAND";
    PurchaseOrderBrandType["WITH_UNCONFIRMED_USER"] = "WITH_UNCONFIRMED_USER";
    PurchaseOrderBrandType["WITH_CONFIRMED_USER"] = "WITH_CONFIRMED_USER";
    PurchaseOrderBrandType["WITH_EXISTING_USER"] = "WITH_EXISTING_USER";
  })(PurchaseOrderBrandType = IBrand.PurchaseOrderBrandType || (IBrand.PurchaseOrderBrandType = {}));
  var IMinimum;
  (function (IMinimum) {
    /**
     * Return an instance of IMinimum with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IMinimum.build = function (partial) {
      return _objectSpread({}, partial !== null && partial !== void 0 ? partial : {});
    };
  })(IMinimum = IBrand.IMinimum || (IBrand.IMinimum = {}));
  /**
   * Apparel team currently only cares about APPAREL & FOOTWEAR & ACCESSORIES,
   * feel free to add more categories if needed.
   */
  var PrimaryCategory;
  (function (PrimaryCategory) {
    /**
     * @deprecated
     */
    PrimaryCategory["APPAREL"] = "APPAREL";
    /**
     * @deprecated
     */
    PrimaryCategory["FOOTWEAR"] = "FOOTWEAR";
    /**
     * @deprecated
     */
    PrimaryCategory["ACCESSORIES"] = "ACCESSORIES";
    PrimaryCategory["OTHER_CATEGORY"] = "OTHER_CATEGORY";
    /**
     * @deprecated
     */
    PrimaryCategory["KIDS_BABY"] = "KIDS_BABY";
    PrimaryCategory["HOME_DECOR"] = "HOME_DECOR";
    PrimaryCategory["FOOD_DRINK"] = "FOOD_DRINK";
    PrimaryCategory["BEAUTY_WELLNESS"] = "BEAUTY_WELLNESS";
    PrimaryCategory["PAPER_NOVELTY"] = "PAPER_NOVELTY";
    PrimaryCategory["PETS"] = "PETS";
    PrimaryCategory["JEWELRY"] = "JEWELRY";
    PrimaryCategory["WOMENS_APPAREL"] = "WOMENS_APPAREL";
    PrimaryCategory["WOMENS_ACCESSORIES"] = "WOMENS_ACCESSORIES";
    PrimaryCategory["MENS_APPAREL"] = "MENS_APPAREL";
    PrimaryCategory["MENS_ACCESSORIES"] = "MENS_ACCESSORIES";
    PrimaryCategory["KIDS_BABY_APPAREL"] = "KIDS_BABY_APPAREL";
    PrimaryCategory["KIDS_BABY_NON_APPAREL"] = "KIDS_BABY_NON_APPAREL";
    PrimaryCategory["RAW_MATERIALS"] = "RAW_MATERIALS";
    PrimaryCategory["CBD_THC"] = "CBD_THC";
  })(PrimaryCategory = IBrand.PrimaryCategory || (IBrand.PrimaryCategory = {}));
  /**
   * List of certifications for this brand, for hackweek 2020 and populated only by wirefilter
   */
  var CertificationType;
  (function (CertificationType) {
    CertificationType["B_CORP"] = "B_CORP";
    CertificationType["GOTS"] = "GOTS";
    CertificationType["USDA_ORGANIC"] = "USDA_ORGANIC";
  })(CertificationType = IBrand.CertificationType || (IBrand.CertificationType = {}));
  /**
   * Size segment is a semi transparent property set on brands populated through a data pipeline
   * this is introduced for the faire direct rewards program and the definitions for each segment can be
   * found here
   * https:www.notion.so/faire/Faire-Direct-Rewards-program-MVP-6bdc27b21c824fd988af029270dfacaf#5fe6f2dbae884b65bcc8875555c2a202
   */
  var SizeSegment;
  (function (SizeSegment) {
    SizeSegment["SIZE_SEGMENT_UNKNOWN"] = "SIZE_SEGMENT_UNKNOWN";
    SizeSegment["SIZE_SEGMENT_1"] = "SIZE_SEGMENT_1";
    SizeSegment["SIZE_SEGMENT_2"] = "SIZE_SEGMENT_2";
    SizeSegment["SIZE_SEGMENT_3"] = "SIZE_SEGMENT_3";
    SizeSegment["SIZE_SEGMENT_4"] = "SIZE_SEGMENT_4";
  })(SizeSegment = IBrand.SizeSegment || (IBrand.SizeSegment = {}));
  var OrderAutoAcceptConfiguration;
  (function (OrderAutoAcceptConfiguration) {
    OrderAutoAcceptConfiguration["ORDER_AUTO_ACCEPT_CONFIGURATION_UNKNOWN"] = "ORDER_AUTO_ACCEPT_CONFIGURATION_UNKNOWN";
    /**
     * [Default] The brand will not automatically accept any new orders.
     */
    OrderAutoAcceptConfiguration["DISABLED"] = "DISABLED";
    /**
     * The brand will automatically accept new orders from reordering retailers.
     */
    OrderAutoAcceptConfiguration["ENABLED_REORDERS"] = "ENABLED_REORDERS";
    /**
     * The brand will automatically accept all new orders.
     */
    OrderAutoAcceptConfiguration["ENABLED_ALL"] = "ENABLED_ALL";
  })(OrderAutoAcceptConfiguration = IBrand.OrderAutoAcceptConfiguration || (IBrand.OrderAutoAcceptConfiguration = {}));
  /**
   * Return an instance of IBrand with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  IBrand.build = function (partial) {
    return _objectSpread({
      categories: [],
      deranked_categories: [],
      images: [],
      social_media_images: [],
      badges: [],
      squared_category_images: {},
      available_terms: [],
      restricted_states: [],
      forbidden_states: [],
      reduced_commission_states: [],
      restricted_countries: [],
      restricted_geo_constraints: [],
      memberships: [],
      story_images: [],
      active_brand_promos: [],
      active_promo_collections: [],
      order_minimum_overrides: [],
      minimums: [],
      certifications: [],
      business_identifiers: [],
      tags: []
    }, partial !== null && partial !== void 0 ? partial : {});
  };
})(IBrand || (IBrand = {}));